module.exports = __webpack_public_path__ + "img/list2.dd5694cf.png";